var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'asc-panel':true,'in':_vm.ctx=='in','out':_vm.ctx!='in','clickable':_vm.clickable},style:((_vm.width)?'width:'+_vm.width:''),on:{"click":e=>_vm.$emit('click',e)}},[_c('div',{staticClass:"action-buttons"},[_vm._t("actions")],2),_vm._v(" "),_c('div',{staticClass:"infos"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }